import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FieldError } from "@/components/States";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const MissingTimesDialog = ({ open, onOpenChange, onConfirm, busy, tid, runDate, statusLabel }) => {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setStart("");
      setEnd("");
      setError("");
    }
  }, [open]);

  const submit = (e) => {
    e.preventDefault();
    if (!start || !end) return setError("Enter both a start and an end time");
    if (end < start) return setError("The end time can't be before the start time");
    onConfirm({ start: `${runDate}T${start}`, end: `${runDate}T${end}` });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid={`${tid}-missing-times-dialog`}>
        <DialogHeader>
          <DialogTitle className="font-display">Add start and end time</DialogTitle>
          <DialogDescription>This address has no start time. Enter the times before marking it {statusLabel}.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} noValidate className="min-w-0 space-y-4">
          <div className="space-y-3">
            <div>
              <Label htmlFor={`${tid}-mt-start`}>Start *</Label>
              <Input id={`${tid}-mt-start`} type="time" value={start} onChange={(e) => { setStart(e.target.value); setError(""); }} className="mt-1.5 block w-full min-w-0 max-w-full appearance-none" data-testid={`${tid}-missing-start-input`} />
            </div>
            <div>
              <Label htmlFor={`${tid}-mt-end`}>End *</Label>
              <Input id={`${tid}-mt-end`} type="time" value={end} onChange={(e) => { setEnd(e.target.value); setError(""); }} className="mt-1.5 block w-full min-w-0 max-w-full appearance-none" data-testid={`${tid}-missing-end-input`} />
            </div>
          </div>
          <FieldError message={error} testId={`${tid}-missing-times-error`} />
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} disabled={busy} data-testid={`${tid}-missing-times-cancel`}>Cancel</Button>
            <Button type="submit" disabled={busy} className="bg-blue-700 hover:bg-blue-800" data-testid={`${tid}-missing-times-save`}>
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Save
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
